import type {
    CreateQuickFilterRequest,
    CreateQuickFilterResponse,
} from "@amzn/ads-blink-client";
import { QuickFilterAliasType } from "@amzn/ads-blink-client";
import type { AsyncState, UseAsyncActions } from "@react-hookz/web";
import { useAsync } from "@react-hookz/web";

import { getBlinkApiClientV2 } from "../../../../api/blinkApi/blinkApi";
import { useAsyncErrorStatusNotification } from "../../../../hooks/notifications/useAsyncErrorStatusNotification";
import { authStore } from "../../../../store/auth";

export type NewQuickFilterFields = Omit<
    CreateQuickFilterRequest,
    "aliasType" | "aliasValue"
>;

export function CreateQuickFilterActionAsync(): [
    AsyncState<CreateQuickFilterResponse | undefined>,
    UseAsyncActions<CreateQuickFilterResponse, [NewQuickFilterFields]>,
] {
    const [state, action] = useAsync(async (fields: NewQuickFilterFields) => {
        // If we ever add in more alias types, we will need to have the alias as an argument instead of hard-coding it
        const request: CreateQuickFilterRequest = {
            aliasType: QuickFilterAliasType.USER,
            aliasValue: authStore.getState().username,
            ...fields,
        };

        return await (await getBlinkApiClientV2()).createQuickFilter(request);
    });

    // Alert the user of any errors we run into
    useAsyncErrorStatusNotification(state);

    return [state, action];
}
